import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { businesses } from '../data/businesses';
type BusinessCardProps = {
  name: string;
  description: string;
  location: string;
  index: number;
  onClick?: () => void;
};
export function BusinessCard({
  name,
  description,
  location,
  index,
  onClick
}: BusinessCardProps) {
  const business = businesses.find(b => b.name === name);
  const image = business?.image;
  return <motion.article initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay: index * 0.05
  }} className="group cursor-pointer flex flex-col h-full bg-white rounded-sm overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 border-b-2 border-transparent hover:border-[#c9a961]" onClick={onClick} data-id="element-36">
      {/* Image */}
      <div className="relative aspect-[4/3] bg-[#1d1d1f] overflow-hidden" data-id="element-37">
        {image ? <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-110" style={{
        backgroundImage: `url('${image}')`
      }} data-id="element-38" /> : <div className="absolute inset-0 flex items-center justify-center" data-id="element-39">
            <span className="font-display text-[64px] text-white/10" data-id="element-40">
              {name.charAt(0)}
            </span>
          </div>}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500" data-id="element-41" />

        <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2 text-white/90 text-[13px] font-medium tracking-wide" data-id="element-42">
          <MapPinIcon className="w-3.5 h-3.5 text-[#c9a961]" data-id="element-43" />
          <span data-id="element-44">{location}</span>
        </div>
      </div>

      <div className="p-8 flex flex-col flex-grow" data-id="element-45">
        <h3 className="font-display text-[22px] font-medium text-[#1d1d1f] mb-3 group-hover:text-[#c9a961] transition-colors duration-300 leading-tight" data-id="element-46">
          {name}
        </h3>

        <p className="text-[#86868b] text-[15px] leading-relaxed line-clamp-3 mb-6 flex-grow font-light" data-id="element-47">
          {description}
        </p>

        <span className="inline-flex items-center gap-2 text-[#c9a961] text-[13px] font-bold uppercase tracking-wider group-hover:gap-3 transition-all duration-300" data-id="element-48">
          View Details <ArrowRightIcon className="w-4 h-4" data-id="element-49" />
        </span>
      </div>
    </motion.article>;
}